import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const FundingEnquiryPurposeRecord = Record({
  description: '',
  id: 0,
  value: '',
});

export default class FundingEnquiryPurpose extends FundingEnquiryPurposeRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, {}), {});

    return new FundingEnquiryPurpose(hydrated);
  }
}
